module.exports = __webpack_public_path__ + "static/media/CA-Icon.62784e6d.svg";